<template>
    <BasicLayout :left='left' :middle='middle' :right='right'>
        <template  v-slot:right_view>
          <div  id='deviceTable' class='h100vh-140'>
            <div class="h-toolbarBg">
                <ejs-toolbar>
                    <e-items>
                        <e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("MCS.add")' :click='addClick'></e-item>
                        <e-item prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("MCS.mod")' :click='modifyClk'></e-item>
                        <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("MCS.del")' :click='delClick'></e-item>
                    </e-items>
                </ejs-toolbar>
                <div class='h-inputBox'>
                    <ejs-textbox :placeholder='$t("Topo.pleaseEnterDeviceName")' v-model='searchValue' @keydown.native.enter='search'></ejs-textbox>
                </div>
            </div>
            <div class='h100 width-100vw h-scroll'>
            <ejs-grid ref='grid' :dataSource="devdata" height='calc(100% - 0px)' allowReordering='true' allowResizing='true' allowExcelExport='true' allowTextWrap='true'>
                <e-columns>
                    <!-- <e-column type="checkbox" headerText='devid' width='50' textAlign='Center'></e-column> -->
                    <e-column  field='name' :headerText='$t("Topo.devName")' textAlign='Center'></e-column>
                    <e-column field='typeCode' :headerText='$t("Topo.devType")' width='150' textAlign='Center' :valueAccessor='deviceTypeFormatter'></e-column>
                    <!-- <e-column field='typeCode' :headerText='$t("Topo.devAttriTrunk")' width='150' textAlign='Center' :valueAccessor='deviceTypeFormatter'></e-column> -->
                    <e-column field='displaySoftwareVersion' :headerText='$t("Topo.devSoftVersion")' width='150' textAlign='Center'></e-column>
                </e-columns>
            </ejs-grid>
             <ejs-pager ref='devpager' @click='getDeviceListData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
            </div>
          </div>
          <CustomDialog ref='devicedialog' :element='devDialog.element' :styles='devDialog.styles' :messages='devDialog.messages'>
                <template v-slot:dialog-content>
                    <add-device ref="adddev" @close='addCancel' ></add-device>
                </template>
            </CustomDialog>
            <CustomDialog ref='updateDevice' :element='updateDevDialog.element' :styles='updateDevDialog.styles' :messages='updateDevDialog.messages'>
                <template v-slot:dialog-content>
                    <UpdateDevice ref="updatedev" @close='updateCancel' ></UpdateDevice>
                </template>
            </CustomDialog>
        </template>
    </BasicLayout>
</template>

<style >

</style>

<script>
import BasicLayout from '../../../layouts/BasicLayout';
import CustomDialog from '../../../components/common/CustomDialog';
import AddDevice from '../../../components/topoconfig/AddDevice';
import UpdateDevice from '../../../components/topoconfig/UpdateDevice';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'DeviceManage',
  components: {
    BasicLayout,
    CustomDialog,
    AddDevice,
    UpdateDevice
  },
  data() {
    return {
        left: {
            show: false,
            name: ''
        },
        middle: {
            show: false,
            name: ''
        },
        right: {
            show: true,
            crumb: this.$t('Topo.devCrumb')
        },
        devdata:{},
        devDialog: {
            element: {
                title: this.$t('Topo.devAdd'),
                // target: '#app',
                isClose: true,
                refName: this.$t('Topo.devMange'),
                buttonGroup: [
                    { click: this.addCancel, buttonModel: { content: this.$t('Topo.cancel') } }, 
                    { click: this.addSubmit, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } },                 
                ]
            },
            styles: {
                width: '800px',
                height: '700px',
                visible: false,
                model: true
            },
            messages: {
                title: this.$t('Topo.devAdd')
            }
        },
        updateDevDialog:{
            element: {
                title:  this.$t('Topo.devModify'),
                // target: '#app',
                isClose: true,
                refName: this.$t('Topo.devMange'),
                buttonGroup: [
                    { click: this.updateCancel, buttonModel: { content: this.$t('Topo.cancel') } },
                    { click: this.updateSubmit, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } }           
                ]
            },
            styles: {
                width: '800px',
                height: '700px',
                visible: false,
                model: true
            },
            messages: {
                title: this.$t('Topo.devModify'),
            }
        },
        searchValue: '',  //模糊搜索条件

        deviceTypemap: new Map()
        .set(10001,this.$t('Topo.devEPC'))
        .set(10002,this.$t('Topo.devhytalkPro'))
        .set(10003,this.$t('Topo.devMCS'))
        .set(10004,this.$t('Topo.deveNodeB'))
        .set(10005,this.$t('Topo.deveNodeBIOPS'))
        .set(10006,this.$t('Topo.deviBS'))
        .set(10007,this.$t('Topo.deviBSB'))
        .set(10008,this.$t('Topo.devODBBU'))
        .set(10009,this.$t('Topo.devgNB'))
        .set(10010,this.$t('Topo.devhytalk')),

       page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
        pageCount: 10
      },
    };
  },
  mounted() {
      this.getDeviceListData();
  },
  methods: {
      addClick() {
        this.$refs.adddev.initData();
        this.$refs.devicedialog.show();
        this.$refs.adddev.bindValidate();

      },
      delClick() {
        const devIdVec = this.getCheckedVals(true);
        if (devIdVec) {
          this.$layer.confirm({
          msg: this.$t('Topo.sureDel'),
          btn1: {
            msg: this.$t('Topo.cancel')
          },
          btn2: {
            msg: this.$t('Topo.confirm'),
            func: this.delDev     
          }
          });
        }
      },
      delDev(){
       
        const devIdVec = this.getCheckedVals(true);
        let devId = JSON.stringify(devIdVec[0]);
        const This = this;
        this.axios.get(`/lte/ems/topo/device/deleteDev/${devId}`).then((response) => {
	        if(response.data === undefined){
	          return;
	        }
	        if( response.status === 200) {
		          if (response.data.errorCode === 'SUCCESS') {
			          	This.$refs.devpager.ej2Instances.currentPage = 1;
			            This.getDeviceListData();
			            EventBus.$emit('toast', {type: 'success', content: this.$t('Topo.delSuccess')});
			            return;
		          } else {
		            	EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
		          }
	        }
      }).catch((error) => { // 请求失败处理
        // console.log('error', error);
      });
      },

      getCheckedVals(selectOnly = false) {
      // x-> false: 不支持多选   true: 支持多选
      const deviceID = [];
      const checkedData = this.getCheckedData(selectOnly);
      for (let i = 0; i < checkedData.length; i++) {
        deviceID.push(checkedData[i].id);
      }
      return deviceID.length === 0 ? false : deviceID;
    },

      getCheckedData(selectOnly) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.pleaseSelect')});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.pleaseSelectOne')});
        return false;
      }
      return selectedRecords;
    },

      modifyClk() {
        var item = this.$refs.grid.getSelectedRecords();
        if(item.length === 1) {
            this.$refs.updateDevice.show();
            this.$refs.updatedev.initData(item[0]);
            this.$refs.updatedev.bindValidate();
            // this.getDeviceListData();
        }
        if(item.length === 0) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.pleaseSelect')});
          return;
        }
      },
      addSubmit() {
        this.$refs.adddev.outputs();
        this.getDeviceListData();
      },
      addCancel() {
        this.$refs.devicedialog.clear();
        this.$refs.devicedialog.close();
        // this.$refs.adddev.initData();
        this.getDeviceListData();
      },
      updateSubmit() {
        this.$refs.updatedev.outputs();
        this.getDeviceListData();
      },
      updateCancel() {
        this.$refs.updateDevice.clear();
        this.$refs.updateDevice.close();
        // this.$refs.updatedev.initData();
        this.getDeviceListData();
      },
      deviceTypeFormatter(field, devdata) {
        return this.deviceTypemap.get(devdata['typeCode']);
      },
      //模糊搜索
      search() {
        const This = this;
        if(This.searchValue !==''){   //模糊搜索时页面初始化
          This.page.pageNo = 1;
        }
        else{
          This.page.pageNo = This.$refs.devpager.ej2Instances.currentPage;
        }
        
        const params ={
        	  pageNo: This.page.pageNo ,
	          pageSize: This.page.pageSize ,
	          name: This.searchValue
        };
        
        this.axios.post(`/lte/ems/topo/device/devPage2`, params ).then(response => {
          	if(response.data === undefined){
	            return;
	        }
	        if(response.status === 200) {
		          if (response.data.errorCode === 'SUCCESS') {
		            This.devdata = response.data.resultVal.result;
		            This.page.totalCount = response.data.resultVal.totalCount;
		          } else {
		            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
		          }
	        }
        });
      
      	/**
        This.$axios.get(`/lte/ems/topo/device/devPage?pageNo=${This.page.pageNo}&pageSize=${This.page.pageSize}&name=${This.searchValue}`)
        .then((response) => {
	          if(response.data === undefined){
	            return;
	          }
	        if(response.status === 200) {
		          if (response.data.errorCode === 'SUCCESS') {
		            This.devdata = response.data.resultVal.result;
		            This.page.totalCount = response.data.resultVal.totalCount;
		          } else {
		            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
		          }
	        }
        }); */
      },

      getDeviceListData() {
      // 获取表格数据
      const This = this;
      This.page.pageNo = This.$refs.devpager.ej2Instances.currentPage;    
      This.$axios.get(`/lte/ems/topo/device/devPage?pageNo=${This.page.pageNo}&pageSize=${This.page.pageSize}&name=${This.searchValue}`)
      .then((response) => {
        if(response.data === undefined){
          return;
        }
      if(response.status === 200) {
        if (response.data.errorCode === 'SUCCESS') {
          //设备管理不显示UNMS网元，以免修改
          const dataResult=response.data.resultVal.result.filter(it=>it.typeCode!=10011);
          This.devdata = dataResult;
          This.page.totalCount = response.data.resultVal.totalCount-1;
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
      }
      });
    },
  }
};
</script>
